export const sliderLabels = {
 // 1
  sustainabilityPressure: [
    "No sustainability concern",
    "Minimal internal discussion",
    "Low visibility in roadmap",
    "Customer pressure noted",
    "Basic ESG commitment",
    "Carbon mapping started",
    "Lifecycle tracking in progress",
    "Supply chain alignment",
    "Automated emissions tagging",
    "Verified ESG reporting",
    "Sustainability as core strategy",
  ],

  // 2
  esgCompliance: [
    "No compliance program",
    "Manual reporting only",
    "Basic ESG policy in place",
    "Initial compliance checklist",
    "Early-stage CSRD alignment",
    "PLM-linked disclosures",
    "Audit-ready ESG reporting",
    "CSRD workflow in PLM",
    "Real-time ESG data exchange",
    "AI-supported ESG tracking",
    "Proactive ESG governance",
 ],

  // 3
  greenProductInnovation: [
    "No sustainable design",
    "Basic material awareness",
    "Recyclability considered",
    "Lifecycle modeling exists",
    "Sustainable design rules applied",
    "Eco-design validation via tools",
    "End-of-life simulations used",
    "Circular design features embedded",
    "Digital twin includes sustainability metrics",
    "Customer-visible green scoring",
    "Green-first product innovation culture",
 ],

  // 4
  supplyChainCircularity: [
    "Linear supply chain",
    "End-of-life not considered",
    "Basic recycling tracking",
    "Recyclability mapped",
    "Supplier EOL compliance in place",
    "Circularity BOM considered",
    "Design-for-remanufacture active",
    "Supplier circularity score used",
    "Platform circular design tools",
    "Digital loop w/ 3rd parties",
    "Fully circular PLM integration",
 ],

  // 5
  supplierDependency: [
    "Fully captive production",
    "Single supplier dependency",
    "Limited dual sourcing",
    "Mapped sourcing risks",
    "Critical supplier flagged",
    "Strategic dual sourcing in place",
    "Geopolitical risk evaluated",
    "Disruption scenario tested",
    "Digital dependency matrix used",
    "Supply resilience scores",
    "Multi-sourcing PLM enabled",
 ],

  // 6
  collaborationNeed: [
    "No collaboration required",
    "Basic file exchange",
    "Email-based interaction",
    "Part portal used occasionally",
    "Cross-department handover exists",
    "PLM sharing with key teams",
    "Change collaboration visible",
    "Active co-creation workflows",
    "Supplier team workspace shared",
    "Real-time digital co-authoring",
    "Global concurrent collaboration",
 ],

  // 7
  geographicSpread: [
    "All operations in 1 location",
    "Manufacturing in 2+ locations",
    "Engineering in 2 regions",
    "Cross-timezone collaboration",
    "Offshore teams involved",
    "Supplier ecosystem globally spread",
    "Tools+ data in multiple sites",
    "Global release coordination",
    "Multi-lingual support required",
    "Geo-specific BOM variants exist",
    "Real-time global synchronization",
 ],

  // 8
  supplierToolsGap: [
    "Suppliers use same PLM",
    "Minor version mismatch",
    "Some offline CAD exchange",
    "No CAD-neutral formats",
    "No change tracking on supplier side",
    "No secure portal access",
    "Only PDFs shared for parts",
    "Delayed BOM updates",
    "Multiple tool mismatches",
    "Manual data sync with suppliers",
    "No PLM-capable suppliers",
 ],

  // 9
  supplierSLAPressure: [
    "No SLAs exist",
    "Basic delivery schedule",
    "Loose tolerance allowed",
    "Design delays tolerated",
    "Time penalties apply",
    "PLM-based delivery expectations",
    "SLA breaches visible",
    "Contracted PLM milestones",
    "Performance scorecards tracked",
    "Service Level AI prediction used",
    "SLA-linked PLM automation active",
 ],

  // 10
  partnerEcosystemMaturity: [
    "No partner PLM connectivity",
    "Manual handover w/ partners",
    "Portal access only",
    "Only manufacturing partners digital",
    "System integrators onboarded",
    "Common data models shared",
    "Co-innovation with tech partners",
    "Digital fabric across ecosystem",
    "Lifecycle transparency shared",
    "Multi-PLM connected ecosystem",
    "Open innovation via PLM mesh",
 ],

  // 11
  serviceRevenue: [
    "Only physical product revenue",
    "Service <5% revenue",
    "Spare part sales exist",
    "Field service optional",
    "Standard warranty processes",
    "Service BOM maintained",
    "Usage data collected",
    "Digital twin extends lifecycle",
    "Predictive service revenue",
    "Service-as-a-platform",
    "Majority revenue from service",
 ],

  // 12
  businessModelShift: [
    "One-time sale model",
    "Basic licensing model",
    "Hardware+ add-ons",
    "Bundles with software",
    "Support as revenue stream",
    "Subscription options exist",
    "Upgrades as service",
    "Data monetization started",
    "Platform ecosystem active",
    "Usage-based pricing",
    "Fully outcome-based model",
 ],

  // 13
  lifecycleMonetization: [
    "No monetization beyond sale",
    "Only spare part sale",
    "SLA monetization exists",
    "Performance-based support",
    "EOL monetization exists",
    "Connected service tracked",
    "Design-use feedback loop",
    "Configuration-based pricing",
    "Predictive maintenance monetized",
    "Twin-based new value streams",
    "Lifecycle-wide monetization",
 ],

  // 14
  digitalThreadMonetization: [
    "No digital thread",
    "Change log used manually",
    "Design-Test linkage visible",
    "Usage data viewed post-facto",
    "Some analytics from lifecycle",
    "Automated change prediction",
    "Part failure analytics linked",
    "Service revenue via analytics",
    "Digital twin fuels roadmap",
    "Monetization strategy formalized",
    "Analytics-as-a-business unit",
 ],

  // 15
  ipPortfolioLeverage: [
    "No IP strategy in PLM",
    "Patents not linked to design",
    "Innovation not tracked in PLM",
    "Designs not IP protected",
    "Some IP policy exists",
    "IP capture workflows exist",
    "IP clearance embedded in release",
    "IP monetization analytics",
    "PLM linked with IP valuation",
    "Smart IP protection active",
    "Strategic IP-driven product plans",
 ],

  // 16
  programMarginUplift: [
    "No margin tracking in PLM",
    "BOM cost only tracked",
    "Cost center variance visible",
    "Cost-to-design iteration",
    "Target costing applied",
    "Change-driven cost delta shown",
    "Reuse linked to margin",
    "Variant costing optimized",
    "Real-time cost-margin feedback",
    "Margin driver analytics",
    "PLM-to-ERP closed loop margin",
 ],

  // 17
  ipCapitalizationReadiness: [
    "No IP assets managed",
    "Design = Document only",
    "Digital models not reusable",
    "IP rights not tracked",
    "Versioning but not valuation",
    "IP inventor workflow mapped",
    "IP asset tagging in PLM",
    "IP lifecycle tracked",
    "Capitalization model in place",
    "Auditable IP value chain",
    "PLM-as-IP Asset Engine",
 ],

  // 18
  mAFrequency: [
    "No M&A activity",
    "Infrequent org changes",
    "Only legal entity mergers",
    "Occasional asset purchases",
    "Multiple org shifts past 5 yrs",
    "PLM reorg needed once",
    "Integration of acquired PLMs",
    "Frequent asset-based buys",
    "Dynamic org-unit ownership",
    "Cross-border integration",
    "Continuous acquisition mode",
 ],

  // 19
  localizationDemand: [
    "Single language, single geo",
    "Static export market",
    "Dual-country distribution",
    "Multi-country same design",
    "Local rules vary by geo",
    "Localized documentation exists",
    "Market-specific variants",
    "Local cert/test per geo",
    "Real-time local requirements",
    "Automated localization engine",
    "Global-local synchronized PLM",
 ],

  // 20
  technicalDebt: [
    "Modern stack",
    "Some legacy CAD formats",
    "Partial old workflows",
    "Hardcoded release paths",
    "Outdated data structures",
    "Old versions of PLM",
    "PLM customizations blocking upgrade",
    "Unowned legacy scripts",
    "Zombie integrations",
    "High migration blockers",
    "Legacy debt halting PLM growth",
 ],

  // 21
  engineeringIPRisk: [
    "Fully secure infra",
    "Basic credential control",
    "Open folders for vendors",
    "No access logs",
    "No IP clearance process",
    "Limited watermarking",
    "Basic export control in PLM",
    "No contract/IP traceability",
    "Frequent IP exposure risk",
    "Critical leak possible",
    "Severe uncontrolled IP spread",
 ],

  // 22
  migrationComplexity: [
    "Modern platform, no migration",
    "Small system upgrade planned",
    "Basic PLM-to-PLM migration",
    "Legacy CAD data cleanup needed",
    "Siloed departments need merge",
    "Process alignment needed",
    "Partial rehosting needed",
    "Deep schema transformation",
    "High interdependency of data",
    "Multiple vendor ecosystems",
    "Full PLM replatforming needed",
 ],

  // 23
  cybersecurityExposure: [
    "Hardened PLM infra",
    "Firewall protected",
    "Internal only access",
    "Outdated OS risk",
    "No threat scans",
    "No change audit logs",
    "No 2FA for access",
    "External users no control",
    "PLM open on VPN",
    "Known exposure detected",
    "Highly vulnerable setup",
 ],

  // 24
  resilienceRequirement: [
    "No resilience mandate",
    "Basic RTO expectations",
    "Data recovery plan exists",
    "Tested failover once",
    "BOM duplication risk known",
    "Critical product recovery mapped",
    "Backup PLM instance exists",
    "Geo-distributed architecture",
    "Self-healing PLM infra",
    "Active-active PLM sync",
    "Real-time DR built in",
 ],

  // 25
  revenueResilience: [
    "Revenue fully linear",
    "One product = most revenue",
    "No recurring revenue",
    "Spare/service dependency",
    "Multi-program coverage exists",
    "Revenue tied to digital services",
    "Diversified product revenue",
    "Insights → revenue stream",
    "Data-driven monetization",
    "AI-coordinated resilience",
    "PLM-secured revenue spread",
 ],

  // 26
  productComplexity: [
    "Mechanical only, few parts",
    "Basic variants",
    "Initial ECAD integration",
    "MCAD+ECAD synchronized",
    "Software in BOM",
    "Simulation involved",
    "1000+ parts/program",
    "Configuration by rules",
    "System-of-systems exists",
    "Multi-layered, cross-domain",
    "Ultra-complex cyber-physical",
 ],

  // 27
  changeFrequency: [
    "Yearly or less",
    "Few times/year",
    "Quarterly",
    "Monthly",
    "Biweekly",
    "Weekly",
    "Multiple/week",
    "Daily",
    "Multiple/day",
    "Near-real-time",
    "Continuous Engineering",
 ],

  // 28
  volumeVarietyMix: [
    "Low volume, low variety",
    "Low variety, moderate volume",
    "Medium volume, few SKUs",
    "High variety low volume",
    "Mixed-model",
    "Batch-variety mismatch",
    "Partially configure-to-order",
    "Multiple streams → same line",
    "High-mix high-volume",
    "Every-order unique",
    "Mass customization in place",
 ],

  // 29
  cadIntensity: [
    "2D only",
    "Basic 3D parts",
    "Simple 3D assemblies",
    "Structured 3D BoMs",
    "Variant CADs for product",
    "MCAD+ECAD linking",
    "Linked 3D JT visualizations",
    "Up-to-date design models",
    "Live design-in-context",
    "CAD = master source",
    "Model-based digital twin",
 ],

  // 30
  lifecycleLength: [
    "1–2 years",
    "2–4 years",
    "4–6 years",
    "6–8 years",
    "8–10 years",
    "10–12 years",
    "12–15 years",
    "15–20 years",
    "20+ years",
    "Over 30 years",
    "Indefinite support lifecycle",
 ],

  // 31
  reusePotential: [
    "No reuse",
    "Unstructured reuse",
    "Excel catalog of reuse",
    "Manual part reuse",
    "Subassembly reuse evident",
    "Library of reuse exists",
    "Reuse tracked in PLM",
    "Searchable reuse policies",
    "Automated reuse suggestions",
    "AI reuse assistants",
    "Predictive reuse simulation",
 ],

  // 32
  partCount: [
    "Under 10 parts",
    "10–50 parts",
    "50–100 parts",
    "100–500 parts",
    "500–1000 parts",
    "1k–5k parts",
    "5k–10k parts",
    "10k–50k parts",
    "50k–100k parts",
    "100k–500k parts",
    "Million+ part configurations",
 ],

  // 33
  productConfigurability: [
    "Single variant",
    "Manual variant duplication",
    "Multiple variants per part",
    "Excel-based variant logic",
    "Basic configuration rules",
    "Config BOM in PLM",
    "Effectivity across configs",
    "Options/features controlled",
    "Model-based config rules",
    "Customer-facing configurators",
    "Smart mass-customization",
 ],

  // 34
  portfolioBreadth: [
    "Single product line",
    "2–3 products",
    "4–6 related products",
    "1–2 domains only",
    "Cross-domain product range",
    "Multiple platforms",
    "Geo-specific SKUs",
    "Options & variants explode",
    "Global portfolio sync needed",
    "10+ programs concurrently",
    "100+ variants in sync",
 ],
  // 35
  programDuration: [
    "Less than 3 months",
    "3–6 months",
    "6–12 months",
    "1–2 years",
    "2–3 years",
    "3–5 years",
    "5–7 years",
    "7–10 years",
    "10–15 years",
    "15–20 years",
    "Over 20 years",
 ],

  // 36
  crossDomainNeed: [
    "Single discipline (e.g., MCAD)",
    "Occasional ECAD interface",
    "Basic SW artifacts outside PLM",
    "Informal x-domain workflows",
    "Two domains managed in PLM",
    "Three domain data tracked",
    "Multidomain coordination exists",
    "MBSE collaboration underway",
    "Full RFLP+ simulation visible",
    "Model+ cross-domain sync",
    "Real-time integrated design",
 ],

  // 37
  sensorizationLevel: [
    "No sensors in product",
    "Sensor optional",
    "Manual sensor retrofit",
    "Basic IoT BOM",
    "Sensors for status data",
    "Multi-sensor tracking",
    "Time-series feedback loop",
    "Sensor → analytics workflow",
    "Feedback → design loop",
    "Sensorized twin connected",
    "Product-as-a-data-platform",
 ],

  // 38
  productAsPlatform: [
    "Standalone product",
    "Manual variants",
    "Design templates reused",
    "Shared components across lines",
    "Platform architecture modeled",
    "Partial PLE reuse",
    "Platform BOM & variant logic",
    "Feature-driven product lines",
    "Product = configurable platform",
    "Model-driven product platform",
    "Strategic product platforming",
 ],

  // 39
  legacyProcessGap: [
    "Fully digital",
    "Minor Excel usage",
    "Some approvals via email",
    "Legacy workflows active",
    "Some outdated ERP links",
    "Manual processes outside PLM",
    "Disconnected change flows",
    "High human intervention",
    "Multiple workarounds",
    "PLM resistance from users",
    "Mostly analog workflows",
 ],

  // 40
  digitalMaturity: [
    "No PLM or CAD",
    "CAD only, manual files",
    "Basic PDM",
    "PLM in pilot or PoC",
    "PLM rolled out",
    "Integrated BOM workflows",
    "CAD-PLM-ERP partial sync",
    "Cross-domain traceability",
    "Digital thread active",
    "Real-time PLM workflows",
    "Autonomous digital ops",
 ],

  // 41
  infraReadiness: [
    "On-premise, outdated infra",
    "Limited network access",
    "Basic VMs for PLM",
    "Shared infra, no PLM scaling",
    "PLM scaling bottlenecks",
    "Decent infra for hybrid cloud",
    "PLM on private cloud",
    "Public cloud adoption started",
    "Auto-scalable infra enabled",
    "Kubernetes PLM ready",
    "Full SaaS-native deployment",
 ],

  // 42
  toolFragmentation: [
    "Single system only",
    "CAD+Excel",
    "PLM+ ERP + CAD",
    "Multiple homegrown tools",
    "No sync between systems",
    "Custom integrations exist",
    "Partial process overlaps",
    "Multi-system conflicts",
    "Users toggle between tools",
    "Disconnected user experiences",
    "High system silos",
 ],

  // 43
  manualExceptions: [
    "No manual exceptions",
    "Few exceptions",
    "Approval outside PLM",
    "BOM edits offline",
    "Frequent Excel workarounds",
    "No audit of exceptions",
    "Exception-heavy workflows",
    "Untracked critical changes",
    "Significant PLM bypass",
    "Governance breakdowns",
    "Chaos in critical flows",
 ],

  // 44
  systemAutomation: [
    "Manual flows only",
    "Basic email alerts",
    "Partial workflow triggers",
    "Change-based auto-notifications",
    "PLM change propagation active",
    "Auto version/release steps",
    "System-level conditions applied",
    "Auto role routing",
    "Intelligent PLM automation",
    "AI-suggested process triggers",
    "End-to-end orchestration",
 ],

  // 45
  exceptionVolume: [
    "No exceptions",
    "1–2/month",
    "Weekly",
    "Biweekly",
    "Daily",
    "Multiple/day",
    "Frequent cross-team escalations",
    "Process bypass common",
    "Workarounds dominate",
    "Every program hits exceptions",
    "Process unusable due to volume",
 ],

  // 46
  testInfrastructure: [
    "No formal test infra",
    "Basic test checklist",
    "Unit tests in some programs",
    "System tests manually tracked",
    "Test traceability exists",
    "PLM links design to test cases",
    "Automated test cycle integrated",
    "Test results feed PLM",
    "Simulation/test feedback loop",
    "Model-based verification in PLM",
    "Digital validation platform",
 ],

  // 47
  legacyCustomizationDebt: [
    "Standard PLM usage",
    "Few UI tweaks only",
    "Deprecated extensions exist",
    "Custom scripts in place",
    "Multiple custom workflows",
    "Hardcoded custom logic",
    "Upgrade issues due to custom code",
    "Unsupported legacy integrations",
    "Shadow systems rely on customizations",
    "Multiple custom layers in stack",
    "High-risk legacy lock-in",
 ],

  // 48
  digitalThreadContinuity: [
    "No digital thread",
    "Basic doc linkage",
    "Design → Manufacturing only",
    "Trace exists in fragments",
    "Release → service trace",
    "Req→Design→Test visible",
    "Multi-system linkage aligned",
    "Real-time thread in pilot",
    "Closed-loop feedback active",
    "Digital twin linked to PLM",
    "Full digital thread deployed",
 ],

  // 49
  skillDiversity: [
    "Only senior PLM users",
    "Homogeneous skillset",
    "Few tool champions",
    "Design-centric users only",
    "Part-time contributors vary",
    "Cross-domain contributors",
    "Program, test, prod included",
    "Strong horizontal skill overlap",
    "PLM analytics, process, admin",
    "Full lifecycle capable teams",
    "Self-optimizing user base",
 ],

  // 50
  userBuyIn: [
    "High resistance",
    "PLM perceived as overhead",
    "Partial support",
    "Power users only",
    "Training partially effective",
    "Adoption slowly growing",
    "PLM helps team KPIs",
    "Appreciation of value exists",
    "Teams drive PLM improvements",
    "Internal advocacy active",
    "PLM = indispensable tool",
 ],

  // 51
  changeResistance: [
    "Complete refusal",
    "High resistance",
    "Change fatigue evident",
    "Passive resistance",
    "Tool adoption slow",
    "Some change agents exist",
    "Willingness for training",
    "Teams request process upgrades",
    "Positive momentum for change",
    "Proactive change teams",
    "PLM as innovation enabler",
 ],
  // 52
  plmTalentAvailability: [
    "No internal PLM talent",
    "One part-time admin",
    "Basic CAD-admin only",
    "Overloaded single SME",
    "Support only via vendor",
    "1–2 certified PLM experts",
    "Internal admin+ process owner",
    "Cross-functional PLM team",
    "Internal trainers available",
    "PLM COE functioning",
    "Dedicated scalable PLM team",
 ],

  // 53
  integrationDepth: [
    "Standalone PLM",
    "CAD only",
    "ERP exports via Excel",
    "CAD-PLM-ERP manually synced",
    "Point-to-point CAD/ERP links",
    "PLM–ERP–MES flow enabled",
    "Req → Design → Mfg link active",
    "Cross-domain, cross-function links",
    "BOM change sync across systems",
    "Live bi-directional integration",
    "Seamless digital enterprise flow",
 ],

  // 54
  cloudOpsDiscipline: [
    "On-prem only",
    "Occasional cloud backup",
    "Non-prod on cloud",
    "Hybrid cloud trials",
    "Cloud migration PoC",
    "Prod PLM in cloud infra",
    "Multi-region PLM hosted",
    "Kubernetes PLM ops",
    "CloudOps CI/CD flows",
    "Immutable PLM deployments",
    "Autonomous cloud-native PLM",
 ],

  // 55
  eventDrivenIntegration: [
    "Batch exports only",
    "Daily data jobs",
    "Scheduled interface scripts",
    "Nightly BOM sync",
    "Change-based triggers in dev",
    "Some pub/sub events handled",
    "Change-driven workflows fire",
    "Integration events managed",
    "Orchestrated system syncs",
    "Event brokers in place",
    "Real-time event mesh ops",
 ],

  // 56
  digitalTwinConvergence: [
    "No twin model",
    "CAD model only",
    "3D visualization twin",
    "Behavioral twin isolated",
    "Connected ops feedback loop",
    "Tied to test and service data",
    "IoT data into design iteration",
    "Twin used in product config",
    "Twin influences roadmap",
    "Twin drives monetization",
    "Twin governs lifecycle value",
 ],

  // 57
  dataLatencyTolerance: [
    "Only real-time accepted",
    "Minutes of delay accepted",
    "Hourly updates fine",
    "Daily sync okay",
    "Tolerates stale BOMs",
    "ERP lag not critical",
    "MES catch-up allowed",
    "Delay >1 day tolerated",
    "Weekly update tolerance",
    "Batch-mode accepted norm",
    "Latency doesn’t impact ops",
 ],

  // 58
  ecosystemLicensingStrategy: [
    "No licensing governance",
    "Internal license management only",
    "Partial user tracking",
    "Vendor tool-dependent",
    "Per-seat unmanaged",
    "Floating license pools",
    "Cross-org license tracking",
    "Supplier access governed",
    "Role-based dynamic assignment",
    "Self-service provisioning",
    "Federated ecosystem licensing",
 ],

  // 59
  crossPlmInteroperability: [
    "Only one PLM supported",
    "Legacy PLM data frozen",
    "CAD data not interoperable",
    "Manual data porting needed",
    "Partially usable JT data",
    "Neutral formats exchanged",
    "Shared ontology exists",
    "Data federated between PLMs",
    "Live link to partner PLMs",
    "Dynamic federation across PLMs",
    "Fully semantic PLM mesh",
 ],

  // 60
  platformEcosystemParticipation: [
    "Isolated system",
    "Email-based partner collaboration",
    "Cloud portal usage in pilot",
    "Some supplier access",
    "Point integration with partner tool",
    "Open APIs used for collab",
    "Linked with supply chain platforms",
    "Part of industry cloud platform",
    "Contributes to external data mesh",
    "Collaborative workflows managed",
    "Live digital ecosystem integration",
 ],

  // 61
  speedSensitivity: [
    "No speed pressure",
    "Minor dev timeline impact",
    "Only final release dates matter",
    "Feature delay tolerable",
    "Weekly milestones important",
    "Late delivery impacts market",
    "Competitor launches hurt",
    "Regulatory timing critical",
    "Customer expectation tight",
    "Missing launch is fatal",
    "Speed = Strategic weapon",
 ],

  // 62
  competitivePressure: [
    "No market disruption",
    "Slow-moving segment",
    "Minor innovation race",
    "New players emerging",
    "Customer shifts visible",
    "Direct competitors innovating",
    "Faster dev cycle needed",
    "Constant cost-pressure exists",
    "Tech disruption ongoing",
    "Aggressive industry digitization",
    "Innovation-to-survive model",
 ],

  // 63
  innovationThroughput: [
    "No innovation focus",
    "One product every few years",
    "Annual model update",
    "Feature releases per quarter",
    "Customer-led features grow",
    "Bi-monthly launches",
    "Frequent test iterations",
    "Weekly change proposals",
    "Daily configuration updates",
    "Continuous innovation delivery",
    "Self-adaptive product innovation",
 ],

  // 64
  customerFeedbackLoop: [
    "No feedback captured",
    "Ad-hoc surveys",
    "Field service inputs shared",
    "Basic issue tracking",
    "Design-change linked to feedback",
    "Feedback tracked in PLM",
    "Customer metrics drive changes",
    "Test results loop into design",
    "Real-time IoT feedback used",
    "Automated issue prediction",
    "Live feedback in twin workflows",
 ],

  // 65
  timeToValueAcceleration: [
    "No visibility into ROI",
    "Payback >3 years",
    "2–3 years",
    "18–24 months",
    "12–18 months",
    "9–12 months",
    "6–9 months",
    "3–6 months",
    "Under 3 months",
    "Immediate measurable wins",
    "Real-time value flow tracked",
 ],

  // 66
  customerCoCreationCapability: [
    "Closed design model",
    "Customer suggestion box",
    "Ad-hoc co-creation events",
    "Input-driven variants allowed",
    "Formal customer engagement team",
    "Beta testing feedback loop",
    "Direct config choices offered",
    "Joint design workshops held",
    "Co-innovation platforms used",
    "Crowd-driven co-creation",
    "Real-time participative design",
 ],

  // 67
  regulatoryBurden: [
    "No formal compliance",
    "Basic quality checks",
    "Manual audit trails",
    "Industry stds applied",
    "Multinational certs needed",
    "Data retention enforced",
    "Design-linked regulatory docs",
    "Digital records for regulators",
    "Auto-tracked cert/test packages",
    "Audit-ready compliance workflows",
    "Proactive regulatory intelligence",
 ],

  // 68
  recallRisk: [
    "Zero failure environment",
    "Minimal post-delivery impact",
    "Recalls extremely rare",
    "Low-volume recall incidents",
    "Known risks in parts",
    "Several field issues yearly",
    "Costly historical recalls",
    "Product lifecycle recall concern",
    "Frequent design updates needed",
    "Recurring service part changes",
    "Recall prevention critical",
 ],
  // 69
  traceabilityNeed: [
    "No traceability",
    "Manual Excel mapping",
    "Basic Req→Design mapping",
    "Partial Design→Test links",
    "Initial trace enforcement",
    "Lifecycle trace in pilot",
    "Req→Design→Test→Release mapped",
    "Cross-domain traceability visible",
    "End-to-end digital flow",
    "Validated trace reports available",
    "Regulatory-grade full trace",
 ],

  // 70
  compliancePenalty: [
    "No penalty impact",
    "Mild financial risk",
    "Single geo-specific risk",
    "Known upcoming compliance pressure",
    "Fines recorded in history",
    "Legal holds managed manually",
    "Impactful cost exposure",
    "Frequent regulatory updates needed",
    "Regulatory gaps detected",
    "Compliance failure costs projected",
    "High legal risk if unaddressed",
 ],

  // 71
  namingDiscipline: [
    "Free-text naming",
    "Loose patterns",
    "Manual enforcement only",
    "Dept-level conventions",
    "Basic object templates",
    "Revisioning auto-applied",
    "Classification structure present",
    "Governed naming+ access",
    "Context-driven naming enforced",
    "Global consistency measured",
    "Zero-error naming policies",
 ],

  // 72
  dataGovernanceQuality: [
    "No access control",
    "Basic folder-level rights",
    "User-based controls",
    "Read/write segregation",
    "Lifecycle gates present",
    "Audit trail and signatures",
    "Data owners defined",
    "Governance workflows embedded",
    "Regulatory-level data control",
    "Federated data governance",
    "Trustless data flow managed",
 ],

  // 73
  endToEndTraceability: [
    "Trace stops at CAD",
    "Design-Test links only",
    "CAD–BoM–Change mapped",
    "PLM→ERP partially synced",
    "Downstream usage visible",
    "Req→Design→Validate visible",
    "Test+ Mfg integrated",
    "Trace to service events",
    "Live trace across domains",
    "Real-time digital twins linked",
    "Full lifecycle trace active",
 ],

  // 74
  dataProvenance: [
    "No ownership tracking",
    "Created by known team",
    "Manual document history",
    "Versioning enforced",
    "Change logs available",
    "Digital signature visible",
    "Role trace available",
    "Author-chain trace exists",
    "System-level provenance",
    "AI-explainable data lineage",
    "Zero-trust data with audit path",
 ],

  // 75
  regulatoryAuditReadiness: [
    "Not auditable",
    "Basic documentation",
    "Inconsistent trace",
    "Manual signoffs",
    "Controlled release flow",
    "Partial digital records",
    "Change history complete",
    "Export-ready traceability",
    "Regulatory alignment mapped",
    "Real-time audit dashboard",
    "Automated audit compliance",
 ],

  // 76
  errorCost: [
    "No known cost",
    "Negligible rework",
    "Few missed handoffs",
    "Delay due to errors",
    "BoM errors observed",
    "Late change = cost spike",
    "Recurring design mistakes",
    "High effort due to manual error",
    "Process errors affect revenue",
    "Cost of error > project margin",
    "Error = reputational/financial loss",
 ],

  // 77
  delayPenalty: [
    "No impact from delay",
    "Low urgency project",
    "Tolerable feature slippage",
    "Some timeline overruns",
    "Late launch lost revenue",
    "Project delay → customer penalty",
    "Compliance delay → fine",
    "Missed cycle → cost",
    "Multi-million loss expected",
    "Lost customers from delay",
    "Delay = existential risk",
 ],

  // 78
  engineeringCost: [
    "Minimal eng cost",
    "Few full-time engineers",
    "Mixed tech team (few roles)",
    "Standard eng cost burden",
    "Rework adds to eng load",
    "Change-driven cost ↑",
    "Design, test loops expensive",
    "Inefficiency drives cost",
    "High burn rate for delays",
    "Eng cost = key project killer",
    "Unsustainable eng overhead",
 ],

  // 79
  reuseLibrary: [
    "No reuse",
    "Occasional manual reuse",
    "Basic part library",
    "Standard parts reused",
    "CAD reuse policies exist",
    "BoM reuse tracked",
    "Subassembly reuse enabled",
    "Rule-based reuse enforced",
    "Analytics for reuse",
    "AI-suggested reuse",
    "Smart reuse across enterprise",
 ],

  // 80
  ipRisk: [
    "Fully secure IP",
    "Low internal access",
    "Manual access logs",
    "Occasional leak risk",
    "No signed handoffs",
    "Export controls missing",
    "Critical IP exposed",
    "Partner risk known",
    "Known incidents in past",
    "IP theft → financial loss",
    "IP risk = high threat",
 ],

  // 81
  aftermarketFocus: [
    "Only product sales",
    "Spare part sales tracked",
    "Reactive service model",
    "Support revenue noted",
    "Basic service BOM exists",
    "Preventive service plans",
    "Predictive service active",
    "Digital twin supports service",
    "PLM to service loop exists",
    "Service platform monetized",
    "Aftermarket = strategic pillar",
 ],

  // 82
  aiReadiness: [
    "No AI infra or intent",
    "Some structured data exists",
    "Basic dashboards exist",
    "Historical data available",
    "Preliminary ML attempts",
    "Training datasets curated",
    "AI use in pilots",
    "Models support workflows",
    "Operational ML in prod",
    "Feedback loops auto-trained",
    "AI-first engineering pipeline",
 ],

  // 83
  analyticsCapability: [
    "No analytics tools used",
    "Excel/manual reports only",
    "Some dashboards",
    "Basic change analytics",
    "Part cost variance tracked",
    "Engineering performance visible",
    "Config & reuse analytics",
    "Predictive metrics dashboards",
    "Causal PLM analytics used",
    "Autonomous analytics alerts",
    "Self-optimizing decision analytics",
 ],

  // 84
  aiCoDesignAdoption: [
    "No AI used in design",
    "Manual variant creation",
    "Excel-based logic",
    "Visual rule builders",
    "AI used in concept stage",
    "AI refines existing models",
    "Design alternatives generated",
    "Simulation-integrated AI",
    "Multi-domain AI assistance",
    "Autonomous co-design loops",
    "AI-led generative engineering",
 ],

  // 85
  intelligentWorkflowOrchestration: [
    "Manual approvals only",
    "Basic status flows",
    "Workflow builder used",
    "Standard automation rules",
    "Rule-driven routing",
    "Trigger-based automation",
    "Conditional multi-step flows",
    "AI-influenced paths",
    "Real-time adaptive workflows",
    "Self-healing process flows",
    "Cognitive decision orchestration",
  ]

};
